/* istanbul ignore file */
import React, { useEffect } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import InfiniteScrollAlarmHistoryTable
  from '../../../alerts/AlarmHistory/AlarmHistoryTable/InfiniteScrollAlarmHistoryTable/InfiniteScrollAlarmHistoryTable';
import QuickAlertLayout from '../../../alerts/QuickAlertPage/QuickAlertLayout/QuickAlertLayout';
import AlertDetailsLayout from '../../../alerts/AlertDetailsPage/AlertDetailsLayout/AlertDetailsLayout';
import ManageSearchLayout from '../../../search/ManageSearchLayout';
import searchType from '../../../../utility/types/SearchType';
import AlertListLayout from '../../../alerts/AlertListLayout/AlertListLayout';
import { selectIsAlertListLocalStorageLoaded } from '../../../../redux/slices/alertListSlice/alertListSlice';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import { fetchQuietTimes, selectQuietTimesCrudStatus } from '../../../../redux/slices/quietTimesSlice/quietTimesSlice';
import {
  fetchTagList,
  selectTagListCrudStatus,
  selectTagListLoading,
} from '../../../../redux/slices/tagListSlice/tagListSlice';
import { clearActiveSearch } from '../../../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import CreateAlertLayout from '../../../xlalerts/alertforms/CreateAlertLayout';
import { fetchDeviceListData, selectDeviceListInitialLoading } from '../../../../redux/slices/deviceList/deviceListSlice';
import EditAlertLayout from '../../../xlalerts/alertforms/EditAlertLayout';
import { fetchFilteredChannelList } from '../../../../redux/slices/channelListSlice/channelListSlice';
import {
  fetchScrubbedUsers,
  selectUserListCrudStatus,
  selectUsersLoading,
} from '../../../../redux/slices/userListSlice/userListSlice';
import RaaRoute from '../../../common/RaaRoute';

function AlertsPage() {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const localStorageLoaded = useSelector(selectIsAlertListLocalStorageLoaded);

  const tagsCrudStatus = useSelector((state) => selectTagListCrudStatus(state));
  const quietTimeCrudStatus = useSelector((state) => selectQuietTimesCrudStatus(state));
  const userListCrudStatus = useSelector(selectUserListCrudStatus);

  // initial fetch for channels needed for edit layout, can remove later
  useEffect(() => {
    dispatch(fetchFilteredChannelList({ filters: [] }));
  }, []);
  useEffect(() => {
    if (tagsCrudStatus === CrudStatus.IDLE || tagsCrudStatus === CrudStatus.PENDING) {
      dispatch(fetchTagList());
    }
    if (quietTimeCrudStatus === CrudStatus.IDLE) {
      dispatch(fetchQuietTimes());
    }
    if (userListCrudStatus === CrudStatus.IDLE) {
      dispatch(fetchScrubbedUsers());
    }
    return () => { dispatch(clearActiveSearch()); };
  }, []);

  const tagListLoading = useSelector(selectTagListLoading);
  const deviceListLoading = useSelector(selectDeviceListInitialLoading);
  const usersLoading = useSelector(selectUsersLoading);

  useEffect(() => {
    dispatch(fetchTagList());
    dispatch(fetchDeviceListData());
    return () => { dispatch(clearActiveSearch()); };
  }, []);

  if (!localStorageLoaded || tagListLoading || deviceListLoading || usersLoading) {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div><ProgressSpinner progressText="Loading..." /></div>
      </div>
    );
  }
  return (
    <Switch>
      <RaaRoute path="/s/alerts" exact>
        <AlertListLayout />
      </RaaRoute>
      <RaaRoute path="/s/alerts/history" exact>
        <InfiniteScrollAlarmHistoryTable />
      </RaaRoute>
      <RaaRoute path="/s/alerts/new" exact>
        <CreateAlertLayout />
      </RaaRoute>
      <RaaRoute path="/s/alerts/quick" exact>
        <QuickAlertLayout />
      </RaaRoute>
      <RaaRoute path="/s/alerts/saved-searches">
        <ManageSearchLayout searchType={searchType.ALERT} />
      </RaaRoute>
      <RaaRoute path={`${path}/:alertId/edit`} exact>
        <EditAlertLayout />
      </RaaRoute>
      <RaaRoute path={`${path}/:id`}>
        <AlertDetailsLayout />
      </RaaRoute>
    </Switch>
  );
}
export { AlertsPage };
export default AlertsPage;
